import React from 'react';

// The checkout page's "review order" step — lets the customer confirm
// exactly which products and quantities are about to be submitted before
// they place the order request.
const OrderReview = ({ cartItemsArray }) => {
  if (!cartItemsArray || cartItemsArray.length === 0) return null;

  return (
    <div className="w-full max-w-md mx-auto p-6 border rounded-lg shadow-md bg-white">
      <h2 className="text-xl font-semibold mb-4 text-center">Review Your Order</h2>
      <ul className="divide-y">
        {cartItemsArray.map((item) => (
          <li key={item._id} className="flex justify-between items-center py-2 text-sm">
            <span className="text-gray-800">
              {item.name} <span className="text-gray-500">× {item.qty}</span>
            </span>
            <span className="font-medium">₹{(item.price * item.qty).toFixed(2)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrderReview;
